import { createSelector } from 'reselect';

const selectSimulations = (s) => s.simulations;

export const selectOptimization = createSelector(
  selectSimulations,
  (_, params) => params,
  (simulations, { type, id }) => {
    return simulations.optimizations[type]?.[id];
  }
);

export const selectInvestmentForecast = createSelector(
  selectSimulations,
  (_, params) => params,
  (simulations, { type, id }) => {
    return simulations.investmentForecasts[type]?.[id];
  }
);

export const selectInvestmentRecommendation = createSelector(
  selectSimulations,
  (_, params) => params,
  (simulations, { type, id }) => {
    return simulations.investmentRecommendations[type]?.[id];
  }
);

export const selectExpectedFees = createSelector(
  selectSimulations,
  (_, params) => params,
  (simulations, { type, id }) => {
    return simulations.expectedFees[type]?.[id];
  }
);
